module.exports = __webpack_public_path__ + "img/6.683de465.jpg";